var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 col-md-11 offset-md-1"},[_c('Breadcrumbs',{staticClass:"col-12"}),_c('h1',{staticClass:"title",attrs:{"id":"scrollTo"}},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"col-12 savings"},[_vm._v("\n\t\t"+_vm._s(_vm.savings)+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }